import Header from "./header";
import Content from "./content";

export const WhyChooseResource = {
	Header: Header,
	Content: Content,
}
